import * as React from 'react';
import classNames from 'classnames';
import AccordionContext, { Expanded } from './AccordionContext';

export interface AccordionProps {
  defaultExpanded?: string;
  multiple?: boolean;
  children?: React.ReactNode;
  className?: string;
}

function Accordion(props: AccordionProps) {
  const { children, multiple, className, defaultExpanded = '' } = props;
  const [expanded, setExpanded] = React.useState<Expanded>({
    [defaultExpanded]: true,
  });

  const handleChange = (section: string, isExpanded: boolean) => {
    setExpanded(
      multiple
        ? { ...expanded, [section]: !isExpanded }
        : { [section]: !isExpanded }
    );
  };

  return (
    <div className={classNames('ui-accordion', className)}>
      <AccordionContext.Provider
        value={{
          expanded,
          toggle: handleChange,
        }}
      >
        {children}
      </AccordionContext.Provider>
    </div>
  );
}

export default Accordion;
